import { useEffect, useState } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { Button, Container, Typography, Box, Tab, Tabs, styled, TextField, MenuItem, Drawer, ListSubheader, Chip } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";
import ListTeachers from "../teachers/ListTeachers";
import ListAule from "../aule/ListAule";
import ListDirettori from "../direttore/ListDirettori";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/it';
import "react-big-calendar/lib/css/react-big-calendar.css";
import html2pdf from "html2pdf.js";
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import ListDigital from "./ListDigital";
import PDFCalendarUpload from "./PDFCalendarUpload";
import ListSedi from "../sedi/ListSedi";
import { ServerConfig } from "../../../connectors/Config";
import { AuthHelper } from "../../controllers/AuthHelper";
import { useNavigate } from "react-router-dom";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import { useSnackBar } from "../../providers/consumers/useSnackBar";
import { getCourseColorStyle, getContrastText, COURSE_COLOR_LEGEND } from "../../../utils/courseColors";

moment.locale('it');
const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);


const getEventStyle = (event) => {
  // Colore in base alla tipologia di corso (con fallback al colore DB se presente).
  const { backgroundColor, color } = getCourseColorStyle(event?.title, event?.colore);
  return { style: { backgroundColor, borderRadius: '6px', opacity: 0.92, color, border: '0px', display: 'block' } };
};

const AntTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: { minWidth: 0 },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  color: '#888',
  fontFamily: ['-apple-system','BlinkMacSystemFont','"Segoe UI"','Roboto','"Helvetica Neue"','Arial','sans-serif','"Apple Color Emoji"','"Segoe UI Emoji"','"Segoe UI Symbol"'].join(','),
  '&:hover': { color: '#40a9ff', opacity: 1 },
  '&.Mui-selected': { fontWeight: theme.typography.fontWeightMedium },
  '&.Mui-focusVisible': { backgroundColor: '#d1eaff' },
}));

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (<Box sx={{ p: 3 }}>{children}</Box>)}
    </div>
  );
}

function a11yProps(index) {
  return { id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}` };
}

const ListCourses = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [availablePackages, setAvailablePackages] = useState([]);
  const [isNewCourse, setIsNewCourse] = useState(true);
  const [savingCourse, setSavingCourse] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());

  const { builder } = useBuilder();
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const refresh = useSelector(state => state.reload);
    const { addAlert } = useSnackBar();

  useEffect(() => { getCertificates(); fetchAvailableCourses(); }, [refresh]);

  const getCertificates = async () => {
    let user = await AuthHelper.getUserFromIdToken();
    const subCurrent = user.Username;
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/courses/${subCurrent}`)).json();
    setCertificates(Array.isArray(res) ? res : []);
    setLoading(false);
  }


  const fetchAvailableCourses = async () => {
     let user = await AuthHelper.getUserFromIdToken();
    const subCurrent = user.Username;
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/prezziario/search/${subCurrent}`)).json();
    setAvailableCourses(Array.isArray(res) ? res : []);
    // Recupera anche i pacchetti attivi del centro per il dropdown di creazione
    try {
      const pkgRes = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/packages/list/${subCurrent}`)).json();
      const attivi = Array.isArray(pkgRes) ? pkgRes.filter(p => p.attivo !== false) : [];
      setAvailablePackages(attivi);
    } catch (e) {
      console.warn("Impossibile caricare i pacchetti", e);
      setAvailablePackages([]);
    }
  }

  const handleClick = (data = {}, name = null) => {
    store.dispatch(clear());
    builder('courses.add');

    const newCourse = !data.row;
    setIsNewCourse(newCourse);

    if(!newCourse){
      Object.keys(data.row).forEach(key =>
        store.dispatch(setFieldState({name:key, value:data.row[key]}))
      );
    }

    setDrawerOpen(true);
  }

  const handleSave = async () => {
  try {
    const state = store.getState().fieldsData;
    const user = await AuthHelper.getUserFromIdToken();
    const sub_centro = user.Username;

    // ================= RAMO PACCHETTO =================
    // Se è stato selezionato un pacchetto, creo N corsi tramite l'endpoint dedicato.
    if (state.isPackage && state.package_id) {
      if (!state.from) {
        addAlert({ message: 'Inserisci la data di inizio', severity: 'warning' });
        return;
      }
      setSavingCourse(true);
      try {
        const res = await fetch(
          `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/school/courses/from-package`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              package_id: state.package_id,
              date_inizio: state.from,
              date_fine: state.to || state.from,
              centro_id: sub_centro,
              digital: state.digital === "Sì",
            }),
          }
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Errore creazione corsi dal pacchetto");

        const nomi = (data.created || []).map(c => c.nome_corso).filter(Boolean).join(", ");
        addAlert({
          message: `${data.message}${nomi ? `: ${nomi}` : ''}`,
          severity: 'success',
        });
        await getCertificates();
        setDrawerOpen(false);
        if (state.from) setCalendarDate(new Date(state.from));
      } catch (e) {
        console.error("Errore pacchetto:", e);
        addAlert({ message: e.message || 'Errore durante la creazione dal pacchetto', severity: 'error' });
      } finally {
        setSavingCourse(false);
      }
      return;
    }
    // =============== FINE RAMO PACCHETTO ===============

   const payload = {
     course: state.corso,                 
     price: state.price ? parseFloat(state.price.replace(',', '.'))  : 0, // default 0 se non c'è valore
     from: state.from ? `${state.from}T00:00:00` : null,
     to: state.to ? `${state.to}T00:00:00` : null,
     digital: state.digital,              
     user: sub_centro,
  };

    const res = await fetch(
      `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/courses`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Errore salvataggio corso");
    }
    else {
    addAlert({
        message: 'Corso creato con successo',
        severity: 'success'
      });

       // ✅ aggiorna subito il calendario
    await getCertificates();

    // ✅ chiudi drawer solo se tutto ok
    setDrawerOpen(false);

    if (state.from) {
  setCalendarDate(new Date(state.from)); // sposta il calendario al mese corretto
} 

    }
   
  } catch (err) {
    console.error("Errore salvataggio:", err);
    alert("Errore durante il salvataggio del corso");
  }
};



const handleCourseChange = (e) => {
  const selectedValue = e.target.value;

  // ✅ salvo il valore selezionato (può essere id_corso oppure "pkg:<id>")
  store.dispatch(setFieldState({ name: "corso", value: selectedValue }));

  // ---- Caso PACCHETTO ("pkg:<id>") ----
  if (typeof selectedValue === "string" && selectedValue.startsWith("pkg:")) {
    const packageId = selectedValue.slice(4);
    const selectedPkg = availablePackages.find(p => p.id === packageId);
    store.dispatch(setFieldState({ name: "isPackage", value: true }));
    store.dispatch(setFieldState({ name: "package_id", value: packageId }));
    // prezzo del pacchetto (informativo)
    if (selectedPkg) {
      let prezzoNum = parseFloat(selectedPkg.prezzo);
      if (isNaN(prezzoNum)) prezzoNum = 0;
      store.dispatch(setFieldState({ name: "price", value: prezzoNum.toFixed(2).replace('.', ',') }));
    }
    return;
  }

  // ---- Caso CORSO SINGOLO ----
  store.dispatch(setFieldState({ name: "isPackage", value: false }));
  store.dispatch(setFieldState({ name: "package_id", value: null }));
  const selectedCourse = availableCourses.find(c => c.id_corso === selectedValue);
  if (selectedCourse) {
    let prezzoNum = parseFloat(selectedCourse.prezzo); // converto in numero
    if (isNaN(prezzoNum)) prezzoNum = 0;              // fallback se non è numero

    const formattedPrice = prezzoNum.toFixed(2).replace('.', ',');
    store.dispatch(setFieldState({ name: "price", value: formattedPrice }));
  }
};




   // ---------- FUNZIONI STAMPA ----------

  const printCalendar = () => {
    if (!certificates.length) return alert("Nessun corso disponibile");
    const monthsOrder = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
    const grouped = {};
    certificates.forEach(course => {
      if(!course.from || !moment(course.from).isValid()) return;
      if(moment(course.from).year() !== moment().year()) return;
      const month = moment(course.from).format('MMMM');
      if(!grouped[month]) grouped[month] = [];
      grouped[month].push(course);
    });

    const tableTemplate = `<html>
      <body style="text-align:center; font-family: Arial, sans-serif;">
        <h1 style="text-align:center;">Calendario annuale corsi</h1>
        {months}
      </body>
    </html>`;

    const monthTemplate = `
      <div style="margin-top: 20px; page-break-after: always;">
        <h2 style="text-align:center;">{month}</h2>
        <table style="border-collapse: collapse; width: 100%; text-align: center;">
          <thead>
            <tr>
              <th style="border:1px solid #000; padding: 8px;">Nome corso</th>
              <th style="border:1px solid #000; padding: 8px;">Dal</th>
              <th style="border:1px solid #000; padding: 8px;">Al</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    `;

    const rowTemplate = `<tr>
      <td style="border:1px solid #000; padding: 6px;">{course}</td>
      <td style="border:1px solid #000; padding: 6px;">{from}</td>
      <td style="border:1px solid #000; padding: 6px;">{to}</td>
    </tr>`;

    const partials = [];
    monthsOrder.forEach(month => {
      if(grouped[month]){
        const rows = grouped[month].sort((a,b)=>moment(a.from)-moment(b.from))
          .map(c=>rowTemplate.replace('{course}', c['nome corso']).replace('{from}', moment(c.from).format('DD/MM/YYYY')).replace('{to}', moment(c.to).format('DD/MM/YYYY'))).join('');
        partials.push(monthTemplate.replace('{month}', `${month.charAt(0).toUpperCase()+month.slice(1)} ${moment().format('YYYY')}`).replace('{rows}', rows));
      }
    });

    html2pdf()
      .set({ filename: `calendario_${moment().format('YYYY')}.pdf`, html2canvas: { useCORS: true }, margin:[10,10,10,10] })
      .from(tableTemplate.replace('{months}', partials.join('')))
      .toPdf().get('pdf').then(pdf=>window.open(pdf.output('bloburl'), '_blank'));
  }

  const printMonthCalendar = async () => {
    const sorted = certificates.filter(c => c.from && moment(c.from).isValid());
    const grouped = {};
    sorted.forEach(c => {
      const month = moment(c.from).format('M');
      if(!grouped[month]) grouped[month] = [];
      grouped[month].push(c);
    });

    const currentMonth = moment().format('M');
    const monthCourses = grouped[currentMonth] || [];
    if(!monthCourses.length) return alert("Nessun corso questo mese");

    const user = await AuthHelper.getUserFromIdToken();
    const aule = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/aule/${user.Username}`)).json();

    const tableTemplate = `<html>
      <body style="text-align:center; font-family: Arial, sans-serif;">
        <h1 style="text-align:center;">Calendario corsi {month}</h1>
        <table style="border-collapse: collapse; width: 100%; text-align: center;">
          <thead>
            <tr>
              <th style="border:1px solid #000; padding: 8px;">Nome corso</th>
              <th style="border:1px solid #000; padding: 8px;">Dal</th>
              <th style="border:1px solid #000; padding: 8px;">Al</th>
              <th style="border:1px solid #000; padding: 8px;">Aula</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </body>
    </html>`;

    const rowTemplate = `<tr>
      <td style="border:1px solid #000; padding: 6px;">{course}</td>
      <td style="border:1px solid #000; padding: 6px;">{from}</td>
      <td style="border:1px solid #000; padding: 6px;">{to}</td>
      <td style="border:1px solid #000; padding: 6px;">{aula}</td>
    </tr>`;

    const rows = monthCourses.map(c => rowTemplate
      .replace('{course}', c['nome corso'])
      .replace('{from}', moment(c.from).format('DD/MM/YYYY'))
      .replace('{to}', moment(c.to).format('DD/MM/YYYY'))
      .replace('{aula}', (aule.find(a=>a.id===c.aula_esame)?.name||'-'))
    ).join('');

    html2pdf()
      .set({ filename: `calendario_mensile_${moment().format('MMMM')}_${moment().format('YYYY')}.pdf`, html2canvas:{useCORS:true}, margin:[10,10,10,10] })
      .from(tableTemplate.replace('{month}', moment().format('MMMM').toUpperCase()).replace('{rows}', rows))
      .toPdf().get('pdf').then(pdf=>window.open(pdf.output('bloburl'), '_blank'));
  }

  const printWeekCalendar = async () => {
    const nextWeekStart = moment().add(1,'week').startOf('week');
    const nextWeekEnd = moment().add(1,'week').endOf('week');

    const weekCourses = certificates.filter(c=>{
      if(!c.data_esame) return false;
      const examDate = moment(c.data_esame,'DD/MM/YYYY');
      return examDate.isBetween(nextWeekStart, nextWeekEnd, null, '[]');
    });

    if(!weekCourses.length) return alert("Nessun corso la prossima settimana");

    const user = await AuthHelper.getUserFromIdToken();
    const aule = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/aule/${user.Username}`)).json();

    const tableTemplate = `<html>
      <body style="text-align:center; font-family: Arial, sans-serif;">
        <h1 style="text-align:center;">Calendario corsi settimana dal {from} al {to}</h1>
        <table style="border-collapse: collapse; width: 100%; text-align: center;">
          <thead>
            <tr>
              <th style="border:1px solid #000; padding: 8px;">Nome corso</th>
              <th style="border:1px solid #000; padding: 8px;">Dal</th>
              <th style="border:1px solid #000; padding: 8px;">Al</th>
              <th style="border:1px solid #000; padding: 8px;">Aula</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </body>
    </html>`;

    const rowTemplate = `<tr>
      <td style="border:1px solid #000; padding: 6px;">{course}</td>
      <td style="border:1px solid #000; padding: 6px;">{from}</td>
      <td style="border:1px solid #000; padding: 6px;">{to}</td>
      <td style="border:1px solid #000; padding: 6px;">{aula}</td>
    </tr>`;

    const rows = weekCourses.map(c => rowTemplate
      .replace('{course}', c['nome corso'])
      .replace('{from}', moment(c.from).format('DD/MM/YYYY'))
      .replace('{to}', moment(c.to).format('DD/MM/YYYY'))
      .replace('{aula}', (aule.find(a=>a.id===c.aula_esame)?.name||'-'))
    ).join('');

    html2pdf()
      .set({ filename: `calendario_settimanale_${nextWeekStart.format('DDMMYYYY')}.pdf`, html2canvas:{useCORS:true}, margin:[10,10,10,10] })
      .from(tableTemplate.replace('{from}', nextWeekStart.format('DD/MM/YYYY')).replace('{to}', nextWeekEnd.format('DD/MM/YYYY')).replace('{rows}', rows))
      .toPdf().get('pdf').then(pdf=>window.open(pdf.output('bloburl'), '_blank'));
  }

  // ---------- FINE FUNZIONI STAMPA ----------



  const onEventDrop = async (data) => {
    setLoading(true);
    const { start, end, event } = data;
    const from = moment(start).startOf('day').format('YYYY-MM-DDT00:00:00');
    const to = moment(end).subtract(1,'day').startOf('day').format('YYYY-MM-DDT00:00:00');
    await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/career-path/course/dates/${event.id}`, { method: 'PUT', body: JSON.stringify({from, to}) });
    await getCertificates();
    setLoading(false);
  }

  const onEventResize = onEventDrop;

  return (
    <Container sx={{paddingLeft:24, paddingRight:24, minWidth:'100vw', marginTop:'3rem'}}>
      <div style={{display:'flex', gap:24, marginBottom:24}}>
        <Button onClick={()=>window.location.href="/dashboard/docenti/accreditamento"} sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}}>Inserisci Domanda Accreditamento Docente</Button>
        <Button onClick={()=>window.location.href="/dashboard/direttori/accreditamento"} sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}}>Inserisci Domanda Accreditamento Direttore</Button>
        <Button onClick={()=>window.location.href="/dashboard/aule/accreditamento"} sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}}>Inserisci Domanda Accreditamento Aule</Button>
      </div>
<     div style={{display:'flex', gap:24, marginBottom:24}}>
        <Button sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}} onClick={printCalendar}>Stampa calendario annuale</Button>
        <Button sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}} onClick={printMonthCalendar}>Stampa calendario mensile</Button>
        <Button sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}} onClick={printWeekCalendar}>Stampa calendario settimanale</Button>
        <Button sx={{backgroundColor:'rgb(191,163,73)', fontWeight:'bold', paddingX:4, paddingY:1, borderRadius:66, fontSize:12}} 
            onClick={async () => {
              const user = await AuthHelper.getUserFromIdToken();
              const header = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
              const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/registro/verbali/${user.Username}`, { method:'POST' })).json();
              const a = document.createElement('a');
              a.href = header + res.file;
              a.download = 'report_verbali.xlsx';
              a.click();
            }}
         >Scarica report verbali</Button>
      </div>
      <Box sx={{ borderBottom:1, borderColor:'divider' }}>
        <Tabs value={value} onChange={(e,val)=>setValue(val)} aria-label="basic tabs example">
          <AntTab label="Calendario Annuale Corsi" {...a11yProps(0)} />
          <AntTab label="Database Docenti Accreditati" {...a11yProps(1)} />
          <AntTab label="Database Aule Accreditate" {...a11yProps(2)} />
          <AntTab label="Database Direttori corsi" {...a11yProps(3)} />
          <AntTab label="Database Sedi Accreditate" {...a11yProps(4)} />
          <AntTab label="Corsi digitali" {...a11yProps(5)} />
          <AntTab label="Importa Calendario PDF" {...a11yProps(6)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        {loading && <ListSkeleton />}
        {!loading && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2, alignItems: 'center' }}>
            <Typography variant="caption" sx={{ fontWeight: 700, mr: 1, color: '#555' }}>
              Legenda colori:
            </Typography>
            {COURSE_COLOR_LEGEND.map((item) => (
              <Box
                key={item.label}
                sx={{
                  backgroundColor: item.color,
                  color: getContrastText(item.color),
                  px: 1, py: 0.25, borderRadius: '12px',
                  fontSize: 11, fontWeight: 600, lineHeight: 1.6,
                }}
              >
                {item.label}
              </Box>
            ))}
          </Box>
        )}
        {!loading && <div style={{height: 700}}>
          <DnDCalendar
            localizer={localizer}
            events={certificates.map(c => ({
              title: c['nome corso'],
              start: moment(c.from).startOf('day').toDate(),
              end: moment(c.to).add(1, 'day').startOf('day').toDate(),
              allDay: true,
              id: c.id,
              course: c['course'],
              colore: c.colore
            }))}
            eventPropGetter={getEventStyle}
            onSelectEvent={e => {
              const endDate = moment(e.end).subtract(1, 'day').toDate();
              navigate(`/dashboard/corso/${e.id}?nome_corso=${encodeURIComponent(e.title)}&id=${e.course}&start=${e.start}&end=${endDate}`);
            }}
            date={calendarDate} // <- controllato dallo stato
            onNavigate={(date) => setCalendarDate(date)} // <- aggiorna lo stato quando navighi manualmente
 
            startAccessor="start"
            endAccessor="end"
            onEventResize={onEventResize}
            onEventDrop={onEventDrop}
            resizable
            popup={false}
            step={40}
            views={['month','day','agenda']}
            defaultView="month"
            style={{height:1080}}
          />
        </div>}
        <FloatingActionButtons onClick={() => handleClick({}, "Crea corso")} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}><ListTeachers /></CustomTabPanel>
      <CustomTabPanel value={value} index={2}><ListAule /></CustomTabPanel>
      <CustomTabPanel value={value} index={3}><ListDirettori /></CustomTabPanel>
      <CustomTabPanel value={value} index={4}><ListSedi /></CustomTabPanel>
      <CustomTabPanel value={value} index={5}><ListDigital /></CustomTabPanel>
      <CustomTabPanel value={value} index={6}><PDFCalendarUpload /></CustomTabPanel>


{/* ---------------------- DRAWER ---------------------- */}
<Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
  
  {/* HEADER */}
  <Box
    sx={{
      width: 400,
      padding: 3,
      background: "linear-gradient(to bottom right, #9DCEE2, #7256CB)",
      color: "#fff",
      //borderBottomLeftRadius: 12,
      //borderBottomRightRadius: 12,
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      {isNewCourse ? "Crea Corso" : "Modifica Corso"}
    </Typography>
  </Box>

  {/* CONTENUTO */}
  <Box sx={{ width: 400, padding: 3 }}>


   <TextField
  select
  label="Corso"
  fullWidth
  sx={{ marginBottom: 2 }}
  value={store.getState().fieldsData?.corso || ""}
  onChange={handleCourseChange}
>
  <MenuItem value="" disabled>
    Seleziona corso o pacchetto
  </MenuItem>

  <ListSubheader sx={{ fontWeight: 700, color: '#333', lineHeight: '32px' }}>
    Corsi Singoli
  </ListSubheader>
  {availableCourses.map(c => (
    <MenuItem key={c.id_corso} value={c.id_corso}>
      {c['nome corso']}
    </MenuItem>
  ))}

  {availablePackages.length > 0 && (
    <ListSubheader sx={{ fontWeight: 700, color: '#333', lineHeight: '32px' }}>
      📦 Pacchetti
    </ListSubheader>
  )}
  {availablePackages.map(p => (
    <MenuItem key={p.id} value={`pkg:${p.id}`}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
        <span role="img" aria-label="pacchetto">📦</span>
        <span style={{ flexGrow: 1 }}>{p.nome}</span>
        <Chip
          label={`${Array.isArray(p.corsi) ? p.corsi.length : 0} corsi`}
          size="small"
          sx={{ backgroundColor: '#040e63', color: '#fff', height: 20, fontSize: 11 }}
        />
      </Box>
    </MenuItem>
  ))}
</TextField>

{/* Riepilogo pacchetto selezionato */}
{store.getState().fieldsData?.isPackage && (() => {
  const pid = store.getState().fieldsData?.package_id;
  const pkg = availablePackages.find(p => p.id === pid);
  if (!pkg) return null;
  return (
    <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, backgroundColor: '#f0f4ff', border: '1px solid #c7d2fe' }}>
      <Typography variant="caption" sx={{ fontWeight: 700, color: '#040e63' }}>
        📦 Pacchetto: {pkg.nome}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, color: '#444' }}>
        Verranno creati {Array.isArray(pkg.corsi) ? pkg.corsi.length : 0} corsi con le stesse date:
        {' '}{(pkg.corsi || []).map(c => c.nome_corso).join(', ')}
      </Typography>
    </Box>
  );
})()}

    {/* -------- PREZZO -------- */}
    <TextField
      label="Prezzo"
      fullWidth
      sx={{ marginBottom: 2 }}
      value={store.getState().fieldsData?.price || ""}
      placeholder="Inserisci prezzo in €"
      
     onChange={(e) => {
    // prendi solo numeri e virgola
    let value = e.target.value.replace(/[^0-9,]/g, '');
    const parts = value.split(',');

    // limitiamo a una sola virgola
    if (parts.length > 2) {
      parts[1] = parts[1].slice(0, 2); // solo due decimali
      value = parts[0] + ',' + parts[1];
    } else if (parts[1]) {
      // se c'è la parte decimale, limitiamo a due cifre
      parts[1] = parts[1].slice(0, 2);
      value = parts.join(',');
    }

    store.dispatch(setFieldState({ name: "price", value }));
  }}

  onBlur={(e) => {
    let value = e.target.value.replace(',', '.');
    let num = parseFloat(value);
    if (isNaN(num)) num = 0;
    const formatted = num.toFixed(2).replace('.', ',');
    store.dispatch(setFieldState({ name: "price", value: formatted }));
  }}



      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ color: "#000" }}>
            €
          </InputAdornment>
        )
      }}
    />

   {/* -------- DATA FINE -------- */}
    <TextField
      label="Data inizio"
      type="date"
      fullWidth
      sx={{ marginBottom: 2 }}
      InputLabelProps={{ shrink: true }}
      value={store.getState().fieldsData?.from || ""}
      onChange={(e) =>
        store.dispatch(setFieldState({ name: "from", value: e.target.value }))
      }
    />

    {/* -------- DATA FINE -------- */}
    <TextField
      label="Data fine"
      type="date"
      fullWidth
      sx={{ marginBottom: 2 }}
      InputLabelProps={{ shrink: true }}
      value={store.getState().fieldsData?.to || ""}
      onChange={(e) =>
        store.dispatch(setFieldState({ name: "to", value: e.target.value }))
      }
    />

    {/* -------- DIGITALE -------- */}
    <FormControl component="fieldset" sx={{ marginBottom: 3 }}>
      <FormLabel sx={{ color: "#000", fontWeight: 500, mb: 1 }}>
        Digitale
      </FormLabel>

      <RadioGroup
        row
        value={store.getState().fieldsData?.digital ?? "No"}
        onChange={(e) =>
          store.dispatch(setFieldState({ name: "digital", value: e.target.value }))
        }
      >
        <FormControlLabel
          value="Sì"
          control={<Radio sx={{ color: "#000", "&.Mui-checked": { color: "#000" } }} />}
          label="Sì"
        />
        <FormControlLabel
          value="No"
          control={<Radio sx={{ color: "#000", "&.Mui-checked": { color: "#000" } }} />}
          label="No"
        />
      </RadioGroup>
    </FormControl>

    {/* -------- SALVA -------- */}
    <Button variant="contained" fullWidth onClick={handleSave} disabled={savingCourse}>
      {savingCourse ? "Creazione in corso…" : "Salva"}
    </Button>

  </Box>
</Drawer>
{/* ---------------------- /DRAWER ---------------------- */}

    </Container>
  );
}

export default ListCourses;
